// extracted by mini-css-extract-plugin
export default {"footer":"S_L","row":"S_fh","menu-column":"S_fj"};